import {
    GET_RAVEN_TRANSACTION_TYPE_DEF,
    GET_RAVEN_TRANSACTION_TYPE_DEF_SUCCESS,
    ADD_RAVEN_TRANSACTION_TYPE_DEF,
    ADD_RAVEN_TRANSACTION_TYPE_DEF_SUCCESS,
    UPDATE_RAVEN_TRANSACTION_TYPE_DEF,
    UPDATE_RAVEN_TRANSACTION_TYPE_DEF_SUCCESS,
    DELETE_RAVEN_TRANSACTION_TYPE_DEF,
    DELETE_RAVEN_TRANSACTION_TYPE_DEF_SUCCESS,
    RAVEN_TRANSACTION_TYPE_DEF_API_ERROR
  } from "./actionTypes"

  export const getRavenTransactionTypeDefList = () => ({
    type: GET_RAVEN_TRANSACTION_TYPE_DEF,
  })
  
  export const getRavenTransactionTypeDefListSuccess = record => ({
    type: GET_RAVEN_TRANSACTION_TYPE_DEF_SUCCESS,
    payload: record,
  })
  
  export const addRavenTransactionTypeDef = record => ({
    type: ADD_RAVEN_TRANSACTION_TYPE_DEF,
    payload: record,
  })
  
  export const addRavenTransactionTypeDefSuccess = record => ({
    type: ADD_RAVEN_TRANSACTION_TYPE_DEF_SUCCESS,
    payload: record,
  })
  
  export const updateRavenTransactionTypeDef = record => ({
    type: UPDATE_RAVEN_TRANSACTION_TYPE_DEF,
    payload: record,
  })
  
  export const updateRavenTransactionTypeDefSuccess = record => ({
    type: UPDATE_RAVEN_TRANSACTION_TYPE_DEF_SUCCESS,
    payload: record,
  })
  
  export const deleteRavenTransactionTypeDef = guid => ({
    type: DELETE_RAVEN_TRANSACTION_TYPE_DEF,
    payload: guid,
  })
  
  export const deleteRavenTransactionTypeDefSuccess = guid => ({
    type: DELETE_RAVEN_TRANSACTION_TYPE_DEF_SUCCESS,
    payload: guid,
  })
  
  export const apiRavenTransactionTypeDefApiError = error => {
    return {
      type: RAVEN_TRANSACTION_TYPE_DEF_API_ERROR,
      payload: error,
    }
  }
  